module.exports = __webpack_public_path__ + "img/web-icon.b842963e.svg";